<template>
    <v-card class="kim-card">
      <v-card-title class="pb-0 py-1">
        <v-list dense two-line>
          <v-list-item >
            <v-list-item-avatar  v-if="specialist">
                <v-img :src="specialist.avatar || getFakeAvatar(specialist.gender)" />
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>
                Atendido por:
              </v-list-item-title>
              <v-list-item-subtitle>
                {{specialist && `${specialist.first_name} ${specialist.last_name}` || ''}}
              </v-list-item-subtitle>
            </v-list-item-content>

          </v-list-item>
        </v-list>
      </v-card-title>
      <v-card-text class="text-left">
        <attention-summary flat hide-titles v-if="derivationEvent" :event="derivationEvent" />
      </v-card-text>
    </v-card>

</template>

<script>

import {getFakeAvatar} from "@/utils/Common";
import {subscribeToPrivateChannelEvents, leaveChannel} from "@/utils/Sockets";
import AttentionSummary from "@/components/appointments/attention/AttentionSummary";

export default {
  name: "Derivation",
  components: {AttentionSummary},
  props: {
    derivationEvent:{
      type: Object,
      required: true
    }
  },
  data(){
    return {
      derivationLocal: null
    }
  },
  computed:{
    derivation(){
      const vm = this
      return vm.derivationEvent && vm.derivationEvent.derivation || null
    },
    specialist(){
      const vm = this
      return vm.derivationEvent &&
          vm.derivationEvent.schedule &&
          vm.derivationEvent.schedule.specialist || null
    },
    roomName(){
      const vm = this
      return vm.derivation && `appointments.derivation.${vm.derivation.id}` || null
    }
  },
  mounted(){
    const vm = this
    vm.setDefault()
    vm.connectToSocket()
  },
  beforeDestroy() {
    const vm = this
    vm.disconnectSocket()
  },
  methods: {
    getFakeAvatar,
    setDefault(){
      const vm = this
      vm.derivationLocal = vm.derivation
    },
    connectToSocket(){
      const vm = this
      if(!vm.roomName) return
      subscribeToPrivateChannelEvents(vm.roomName, {
        'DerivationUpdated': vm.onDerivationUpdated
      })
    },
    disconnectSocket(){
      const vm = this
      leaveChannel(vm.roomName)
    },
    onDerivationUpdated({derivation}){
      const vm = this
      vm.derivationLocal = derivation
      vm.$emit('change', derivation)
      console.log('derivation changed', derivation)
    }
  },
  watch:{
    derivation(val){
      if(val){
        this.setDefault()
      }
    }
  }
}
</script>

<style scoped>

</style>
